import { render, staticRenderFns } from "./DigiBoardListForCalendar.vue?vue&type=template&id=6aafd093&scoped=true"
import script from "./DigiBoardListForCalendar.vue?vue&type=script&lang=js"
export * from "./DigiBoardListForCalendar.vue?vue&type=script&lang=js"
import style0 from "./DigiBoardListForCalendar.vue?vue&type=style&index=0&id=6aafd093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aafd093",
  null
  
)

export default component.exports